"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemorySharedVariablesService = void 0;
exports.validateSetSharedVariableArgs = validateSetSharedVariableArgs;
const VariableStore_1 = require("./VariableStore");
const sharedDataRichText_1 = require("../utils/sharedDataRichText");
/**
 * Validates a {@link setSharedVariable} call against adventure shared variable declarations.
 */
function validateSetSharedVariableArgs(adventure, variableName, value) {
    const name = (variableName ?? '').toString().trim();
    if (!name) {
        throw new Error('Shared variable name cannot be empty');
    }
    const declaration = (0, sharedDataRichText_1.findSharedVariableDeclaration)(adventure?.sharedVariables, name);
    if (!declaration) {
        throw new Error(`Shared variable '${name}' is not declared`);
    }
    const inferredType = VariableStore_1.VariableStore.inferVariableType(value);
    if (inferredType !== declaration.type) {
        throw new Error(`Shared variable '${name}' expects type '${declaration.type}' but received '${inferredType}'`);
    }
    return declaration;
}
/** In-memory queue for engine tests and local harnesses. */
class InMemorySharedVariablesService {
    constructor() {
        this.pendingByPlayer = new Map();
    }
    queueSharedVariableWrite(variableName, value, context) {
        const list = this.pendingByPlayer.get(context.playerId) ?? [];
        list.push({
            variableName,
            value,
            ...(context.targetUserId ? { targetUserId: context.targetUserId } : {})
        });
        this.pendingByPlayer.set(context.playerId, list);
    }
    getPendingWrites(playerId) {
        return [...(this.pendingByPlayer.get(playerId) ?? [])];
    }
    clearPendingWrites(playerId) {
        this.pendingByPlayer.delete(playerId);
    }
}
exports.InMemorySharedVariablesService = InMemorySharedVariablesService;
//# sourceMappingURL=SharedVariablesService.js.map